function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.14 8.405c-.164-.14-.245-.21-.275-.292a.333.333 0 010-.226c.03-.083.111-.152.274-.292l5.647-4.84c.28-.24.42-.36.54-.363a.333.333 0 01.266.122c.075.092.075.277.075.646v2.863A6.444 6.444 0 0114 12.367v.408a7.6 7.6 0 00-5.333-2.728v2.793c0 .37 0 .554-.075.646a.333.333 0 01-.267.122c-.119-.002-.259-.123-.539-.363L2.14 8.405z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgReplyNew = function SvgReplyNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#666A72"
  }, props), _ref);
};

export default SvgReplyNew;